import {
  Component, OnInit, Inject, Injector, forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { MomentService, OSharedModule } from 'ontimize-web-ngx';
import { OLightTableComponent } from './o-light-table.component';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_LIGHT_TABLE_COLUMN = [
  'id',
  'title',
  'otype: type',
  'format',
  'pipe',
  'flex'
];

export const DEFAULT_OUTPUTS_O_LIGHT_TABLE_COLUMN = [

];


export class OLightTableColumnComponent implements OnInit {

  public static DEFAULT_INPUTS_O_LIGHT_TABLE_COLUMN = DEFAULT_INPUTS_O_LIGHT_TABLE_COLUMN;
  public static DEFAULT_OUTPUTS_O_LIGHT_TABLE_COLUMN = DEFAULT_OUTPUTS_O_LIGHT_TABLE_COLUMN;

  public static DATE_TYPE: string = 'date';

  id: string;
  title: string = '';
  otype: string = 'text';
  format: string;
  flex: string;

  protected _table: any;

  private momentSrv: MomentService;

  constructor(  _table: OLightTableComponent,
    protected injector: Injector) {
    this.momentSrv = injector.get(MomentService);
    this._table = _table;
  }

  ngOnInit() {
    this._table.registerColumn(this);
  }

  getId() {
    return this.id;
  }

  getRenderedValue(value) {
    if (value) {
      switch (this.otype) {
        case OLightTableColumnComponent.DATE_TYPE: value = this.parseDate(value); break;
        default: break;
      }
    }
    return value;
  }

  parseDate(value: any): any {
    var result = '';
    result = this.momentSrv.parseDate(value, this.format);
    return result;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-light-table-column',
  template: `

  `,
  styles: [`

  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIGHT_TABLE_COLUMN
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIGHT_TABLE_COLUMN
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OLightTableComponent, decorators: [{ type: Inject, args: [forwardRef(() => OLightTableComponent), ] }, ]},
{type: Injector, },
];
}



export class OLightTableColumnModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OLightTableColumnComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OLightTableColumnComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
